import { useEffect, useState } from 'react';
import { Modal } from '@fasstech/middle-design-system';
import PropTypes from 'prop-types';
import {
  isEmailValid,
  isEmailValidAndRequired,
  isMobilePhoneNumberValid
} from '@@viewHelpers/validations';
import DisplayErrorMessage from '@@viewCommonComponents/displayer/DisplayErrorMessage';
import { isNilOrEmpty } from '@@serverHelpers/index.mjs';
import { ControlledInput, ControlledPhoneInput } from '@@viewCommonComponents/controlled';
import { not } from 'ramda';

const GroupHealthConfirmationModal = ({ isDisplayed, phoneIndicatives, confirm, getMiddleText, close, form }) => {
  const [displayError, setDisplayError] = useState(false);

  const {
    watch
  } = form;

  const mailValues = watch('decisionMakerContact.emails.0.value');
  const phoneValues = watch('decisionMakerContact.phones.0.number');

  useEffect(() => {
    if (
      isNilOrEmpty(mailValues) ||
      isNilOrEmpty(phoneValues) ||
      not(isEmailValid(mailValues)) ||
      not(isMobilePhoneNumberValid(phoneValues))
    ) {
      return setDisplayError(true);
    } else {
      setDisplayError(false);
    }
  }, [mailValues, phoneValues]);

  return (
    <Modal
      isDisplayed={isDisplayed}
      button1Label={'Confirmer l\'exactitude de ces informations'}
      button2Label={'Annuler'}
      onClose={close}
      onClick1={confirm}
      onClick2={close}
      icon="circleReject">
      <div className="text-2xl font-semibold mb-4">Vérifiez ces informations</div>

      <div className="inline-flex w-full gap-2">
        <ControlledPhoneInput
          name="decisionMakerContact.phones.0"
          label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_TELEPHONE_LABEL')}
          form={form}
          rules={isMobilePhoneNumberValid()}
          isInternational
          options={phoneIndicatives}
          containerClassName="md:w-full!"
          data-testid="DECISION_MAKER_PHONE_INPUT"
        />
      </div>

      <ControlledInput
        name="decisionMakerContact.emails.0.value"
        label={getMiddleText('ENTREPRISE_CONTACT_DECIDEUR_EMAIL_LABEL')}
        form={form}
        rules={isEmailValidAndRequired}
        containerClassName="mt-4 md:w-full!"
        data-testid="decisionMakerEmail"
      />

      {displayError && (
        <DisplayErrorMessage
          text={getMiddleText('GENERAL_COMMON_TEXTS_TAB_ACTION_ERROR_WARNING_DESCRIPTION')}
        />
      )}
    </Modal>
  );
};

GroupHealthConfirmationModal.propTypes = {
  isDisplayed: PropTypes.bool,
  phoneIndicatives: PropTypes.array,
  confirm: PropTypes.func,
  getMiddleText: PropTypes.func,
  close: PropTypes.func,
  form: PropTypes.object
};

export default GroupHealthConfirmationModal;
